module.exports = __webpack_public_path__ + "media/styles/images/svg/people-check-purple-fa64d3967db5cff328609e7a8cf854d2.svg";